import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/favorites/favorites.ts
var getFavorites = (options) => {
  return customInstance(
    {
      url: `/api/v1/favorites/listings`,
      method: "GET"
    },
    options
  );
};
var createFavorites = (createFavoritesRequest, options) => {
  return customInstance(
    {
      url: `/api/v1/favorites/listings`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFavoritesRequest
    },
    options
  );
};
var deleteAllFavorites = (options) => {
  return customInstance(
    {
      url: `/api/v1/favorites/listings`,
      method: "DELETE"
    },
    options
  );
};
var deleteFavoriteByListingId = (listingId, options) => {
  return customInstance(
    {
      url: `/api/v1/favorites/listing/${listingId}`,
      method: "DELETE"
    },
    options
  );
};

export {
  getFavorites,
  createFavorites,
  deleteAllFavorites,
  deleteFavoriteByListingId
};
